import { ConfigProvider, Drawer, Input } from 'antd';
import styled from 'styled-components';
import { Button, Colors, Row, Text } from 'basic-ui-lib';
import { RadioButtons } from 'basic-ui-lib/components/RadioButtons';
import { useMemo, useState } from 'react';

interface StorePickerModalProps {
  open?: boolean;
  value?: string;
  onChange?: (storeId: string) => void;
  listStores?: { label: string; value: string }[];
  onClose?: () => void;
}

const StorePickerModal = ({ value, onChange, listStores, open, onClose }: StorePickerModalProps) => {
  const [storeId, setStoreId] = useState(value || '');
  const [search, setSearch] = useState('');

  const handleChoose = () => {
    onChange?.(storeId);
    onClose?.();
  };

  const filteredStores = useMemo(() => {
    if (!search) return listStores || [];
    return (listStores || []).filter((store) =>
      store.label.toLowerCase().includes(search.toLowerCase())
    );
  }, [listStores, search]);
  
  return (
    <ConfigProvider>
      <StyledDrawer
        title={
          <Row flex={1} justifyContent='center' alignItems='center'>
            <Text title_h6 semibold center>
              Store
            </Text>
          </Row>
        }
        placement='bottom'
        closable={false}
        onClose={onClose}
        open={open}
        height='80%'
        footer={
          <Row>
            <Button type_cancel lg onClick={onClose} style={{ width: '100%' }}>
              Close
            </Button>
            <Button type_second lg style={{ width: '100%' }} onClick={handleChoose}>
              OK
            </Button>
          </Row>
        }
        destroyOnClose
        style={{ borderRadius: '10px 10px 0px 0px' }}
      >
          <SearchRow>
            <CustomSearch
              allowClear
              placeholder='Search store...'
              value={search}
              onChange={(event) => setSearch(event.target.value)}
              size='large'
            />
          </SearchRow>
        <RadioButtons options={filteredStores} value={storeId} onChange={setStoreId} className='radio-styled' />
      </StyledDrawer>
    </ConfigProvider>
  );
};

StorePickerModal.displayName = 'StorePickerModal';
export default StorePickerModal;

const StyledDrawer = styled(Drawer)`
  .ant-drawer-body {
    padding: 16px 16px 32px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    background-color: ${Colors.neutral.bg[2]};
  }

  .ant-drawer-footer {
    padding: 16px 16px;
    box-shadow: 0px -4px 8px 0px #0000001a;
    background-color: ${Colors.neutral.bg[1]};
  }

  .radio-styled {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    row-gap: 16px;
    .custom-text {
      font-size: 16px;
    } 
  }
`;

const SearchRow = styled.div`
  width: 100%;
`;

const CustomSearch = styled(Input.Search)`
  .ant-input-affix-wrapper {
    padding: 0 12px;
  }

  .ant-input-search-button .anticon {
    font-size: 18px;
  }

  .ant-input-suffix {
    .anticon {
      font-size: 18px;
    }
  }
`;